import React                   from 'react';
import PropTypes               from 'prop-types';
import {needVipYesterdayOffer} from '../dailyBonusHelpers';

const VipBadge = (props) => {
	const needVip = !!props.conditions && needVipYesterdayOffer(props.conditions);
	return needVip || props.show
		? <div className='dailybonus-badge --vip'><i className='icon -icon-person-vip' />VIP</div>
		: null;
};

VipBadge.propTypes = {
	conditions: PropTypes.array,
	show:       PropTypes.bool,
};

VipBadge.defaultProps = {
	conditions: [],
	show:       false,
};

export default VipBadge;
